import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api/axios";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  /**
   * auth shape:
   * {
   *   user: { id, username, role }
   *   token: string
   * }
   */
  const [auth, setAuth] = useState(null);

  // 🔁 rehydrate auth on app load
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const userRaw = localStorage.getItem("auth_user");

    if (!token || !userRaw) return;

    try {
      const user = JSON.parse(userRaw);

      setAuth({ user, token });

      // attach token to axios
      api.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token}`;
    } catch {
      // corrupted data → reset
      localStorage.removeItem("accessToken");
      localStorage.removeItem("auth_user");
    }
  }, []);

  const login = (user) => {
    const token = localStorage.getItem("accessToken");

    setAuth({ user, token });

    // persist user for refresh
    localStorage.setItem("auth_user", JSON.stringify(user));
  };

  const logout = () => {
    setAuth(null);

    localStorage.removeItem("accessToken");
    localStorage.removeItem("token_expires");
    localStorage.removeItem("auth_user");

    delete api.defaults.headers.common["Authorization"];
  };

  const value = {
    user: auth?.user || null,
    role: auth?.user?.role || null,
    token: auth?.token || null,
    isAuthenticated: !!auth,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used inside AuthProvider");
  }
  return ctx;
};
